
import { CEREALES, nombresCereales } from '../../../config/cereales'
import { TABLE_REPORTE_ESTADO_POR_CEREAL_TRIGO,
  TABLE_REPORTE_ESTADO_POR_CEREAL_SOJA,
  TABLE_REPORTE_ESTADO_POR_CEREAL_MAIZ,
  TABLE_REPORTE_ESTADO_POR_CEREAL_CEBADAFO,
  TABLE_REPORTE_ESTADO_POR_CEREAL_CEBADACE,
  TABLE_REPORTE_ESTADO_POR_CEREAL_PELLETGC,
  TABLE_REPORTE_ESTADO_POR_CEREAL_PELLETSJ,
  TABLE_REPORTE_ESTADO_POR_CEREAL_PELLETSC,
  TABLE_REPORTE_ESTADO_POR_CEREAL_PELLETCG,
  TABLE_REPORTE_ESTADO_POR_CEREAL_PELLETCS,
  TABLE_TOTAL_ESTADO_POR_CEREAL_TRIGO,
  TABLE_TOTAL_ESTADO_POR_CEREAL_SOJA,
  TABLE_TOTAL_ESTADO_POR_CEREAL_MAIZ,
  TABLE_TOTAL_ESTADO_POR_CEREAL_CEBADAFO,
  TABLE_TOTAL_ESTADO_POR_CEREAL_CEBADACE,
  TABLE_TOTAL_ESTADO_POR_CEREAL_PELLETGC,
  TABLE_TOTAL_ESTADO_POR_CEREAL_PELLETSJ,
  TABLE_TOTAL_ESTADO_POR_CEREAL_PELLETSC,
  TABLE_TOTAL_ESTADO_POR_CEREAL_PELLETCG,
  TABLE_TOTAL_ESTADO_POR_CEREAL_PELLETCS
} from '../../../config/tables'
import { ReportePorCerealService } from '../../../models/ReportePorCereal/ReportePorCerealService'
import { ReportePorCerealUtils } from '../../../models/ReportePorCereal/ReportePorCerealUtils'
import { COLUMNS, COLUMNS_TOTALES } from './constantesTablaReportePorCereal'

export function fetchSectores () {
  return async dispatch => {
    const tabla = [
      TABLE_REPORTE_ESTADO_POR_CEREAL_TRIGO,
      TABLE_REPORTE_ESTADO_POR_CEREAL_SOJA,
      TABLE_REPORTE_ESTADO_POR_CEREAL_MAIZ,
      TABLE_REPORTE_ESTADO_POR_CEREAL_CEBADAFO,
      TABLE_REPORTE_ESTADO_POR_CEREAL_CEBADACE,
      TABLE_REPORTE_ESTADO_POR_CEREAL_PELLETGC,
      TABLE_REPORTE_ESTADO_POR_CEREAL_PELLETSJ,
      TABLE_REPORTE_ESTADO_POR_CEREAL_PELLETSC,
      TABLE_REPORTE_ESTADO_POR_CEREAL_PELLETCG,
      TABLE_REPORTE_ESTADO_POR_CEREAL_PELLETCS
    ]
    const tablaTotales = [
      TABLE_TOTAL_ESTADO_POR_CEREAL_TRIGO,
      TABLE_TOTAL_ESTADO_POR_CEREAL_SOJA,
      TABLE_TOTAL_ESTADO_POR_CEREAL_MAIZ,
      TABLE_TOTAL_ESTADO_POR_CEREAL_CEBADAFO,
      TABLE_TOTAL_ESTADO_POR_CEREAL_CEBADACE,
      TABLE_TOTAL_ESTADO_POR_CEREAL_PELLETGC,
      TABLE_TOTAL_ESTADO_POR_CEREAL_PELLETSJ,
      TABLE_TOTAL_ESTADO_POR_CEREAL_PELLETSC,
      TABLE_TOTAL_ESTADO_POR_CEREAL_PELLETCG,
      TABLE_TOTAL_ESTADO_POR_CEREAL_PELLETCS
    ]
    // for (let i = 0; i < CEREALES.length; i++) {
    //   tabla.push(`TABLE_REPORTE_ESTADO_POR_CEREAL_${CEREALES[i]}`)
    //   tablaTotales.push(`TABLE_TOTAL_ESTADO_POR_CEREAL_${CEREALES[i]}`)
    // }
    for (let i = 0; i < CEREALES.length; i++) {
      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          isLoading: true
        },
        id: tabla[i]
      })
      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          isLoading: true
        },
        id: tablaTotales[i]
      })
    }
    const parsedData = []
    const parsedDataTotales = []
    for (let i = 0; i < CEREALES.length; i++) {
      console.log('cereal', CEREALES[i])
      const dataSilos = await ReportePorCerealService.getReporteDeCerealDetallado(CEREALES[i])
      console.log('data silos', dataSilos)
      const dataTotales = await ReportePorCerealService.getReporteDeCerealTotales(CEREALES[i])
      console.log('data totales', dataTotales)

      parsedDataTotales[i] = dataTotales
      parsedData[i] = ReportePorCerealUtils.parseDataCombinada(dataSilos, dataTotales)
      console.log('data parseada', parsedData[i])
      console.log('totales parseada', parsedDataTotales[i])
      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          columns: COLUMNS_TOTALES,
          data: parsedDataTotales[i].filas,
          title: `Totales por Cereal ${nombresCereales[CEREALES[i]]}`,
          isLoading: false,
          extraOptions: {
            customToolbar: null,
            print: false,
            pagination: false,
            download: false,
            filter: false,
            search: false,
            viewColumns: false
          }
        },
        id: tablaTotales[i]
      })
      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          columns: COLUMNS,
          data: parsedData[i],
          title: `Reporte Estado Por Cereal ${nombresCereales[CEREALES[i]]}`,
          isLoading: false,
          extraOptions: {
            pagination: false
          }
        },
        id: tabla[i]
      })
    }

    // for (let i = 0; i < CEREALES.length; i++) {
    //   const dataSilos = await ReportePorCerealService.getReporteDeCerealDetallado(CEREALES[i])
    //   const dataTotales = await ReportePorCerealService.getReporteDeCerealTotales(CEREALES[i])
    //   const parsedData = ReportePorCerealUtils.parseDataCombinada(dataSilos, dataTotales)
    //   dataTotal.push(...parsedData)
    // }

    // dispatch({
    //   type: 'UPDATE_MUITABLE',
    //   newState: {
    //     columns: COLUMNS,
    //     data: dataTotal,
    //     title: `Reporte Estado Por Cereal`,
    //     isLoading: false
    //   },
    //   id: TABLE_REPORTE_ESTADO_POR_CEREAL
    // })
  }
}
